import * as React from "react";

import { LoggedInHTTPError } from "@impero-com/common/errorPages/loggedInHTTPError";
import { useLocation } from "react-router-dom";

interface HashSwitchProps {
    hashRoutes: Record<string, React.ReactElement | null>;
}

type HashSwitchWithRouterProps = HashSwitchProps;

function HashSwitch({
    hashRoutes,
}: HashSwitchWithRouterProps): React.ReactElement | null {
    const { hash } = useLocation();
    const node = hashRoutes[hash];
    if (node) {
        return node;
    } else {
        return <LoggedInHTTPError code={404} />;
    }
}

export { HashSwitch };
